<script lang="ts" setup>
export type TagType =
  | 'default'
  | 'primary'
  | 'success'
  | 'error'
  | 'warning'
  | 'blue'
  | 'transparent';

interface Props {
  type?: TagType;
  compact?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  type: 'default',
  compact: false,
});
</script>

<template>
  <div
    class="ui-tag"
    :class="`${props.type} ${props.compact ? 'compact' : ''}`"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.ui-tag {
  display: flex;
  align-items: center;
  gap: var(--space-8);
  padding: var(--space-4) var(--space-8);
  border-radius: var(--border-radius-16);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-12);
  background: var(--color-gray-50);
  white-space: nowrap;
  width: fit-content;

  :deep(svg) {
    height: px(16);
    width: px(16);
  }

  &.primary {
    color: var(--color-primary-700);
    background: var(--color-primary-50);
    :deep(svg) {
      stroke: var(--color-primary-500);
    }
  }

  &.success {
    color: var(--color-success-700);
    background: var(--color-success-50);
    :deep(svg) {
      stroke: var(--color-success-500);
    }
  }

  &.warning {
    color: var(--color-warning-500);
    background: var(--color-warning-50);
    :deep(svg) {
      stroke: var(--color-warning-500);
    }
  }

  &.error {
    color: var(--color-error-500);
    background: var(--color-error-50);
    :deep(svg) {
      stroke: var(--color-error-500);
    }
  }

  &.blue {
    background-color: #f8f9fc;
    color: #363f72;
  }

  &.transparent {
    background: transparent;
    :deep(svg) {
      stroke: var(--color-error-500);
    }
  }

  &.compact {
    font-weight: var(--font-weight-bold);
    height: px(24);
  }
}
</style>
